<template>
  <div>
    <h4>{{ title | capitalize }}</h4>

    <div class="progress mb-3">
      <div v-for="item in repartition"
           :key="item.id"
           role="progressbar"
           class="progress-bar"
           :class="item.onClick ? 'pointer' : null"
           :style="{ width: item.percentage + '%', backgroundColor: item.color }"
           @click="item.onClick ? item.onClick() : null"
      >
        <span v-if="item.percentage > 0">{{ item.name }}</span>
      </div>
    </div>

    <div v-for="(line, index) in legend" :key="index" class="row">
      <div v-for="item in line"
           :key="item.id"
           class="col-md-3 d-flex justify-content-between align-items-center"
           :class="item.onClick ? 'pointer' : null"
           @click="item.onClick ? item.onClick() : null"
      >
        <span>
          <span class="legend-color" :style="{ backgroundColor: item.color }" />
          {{ item.name | capitalize }}
        </span>
        <span class="mr3">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { filter } from 'lodash-es'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    // An array of objects with:
    // - id
    // - name
    // - value
    // - percentage
    // - color
    // - onClick
    repartition: {
      type: Array,
      required: true
    }
  },

  computed: {
    // Reorganize legend to be read column after column, not line after line
    legend () {
      // 4 columns
      const nbLines = Math.ceil(this.repartition.length / 4)

      const legend = []
      for (let i = 0; i < nbLines; i++) {
        legend.push(filter(this.repartition, (status, index) => index % nbLines === i))
      }

      return legend
    }
  }
}
</script>

<style scoped lang="scss">
  .progress {
    display: flex;
    align-items: center;
    height: 28px;

    .progress-bar {
      height: 22px;
      transition-timing-function: ease-in;
      transition-duration: 0.2s;
      transition-property: all;

      &:hover {
        height: 26px;
      }
    }
  }

  .legend-color {
    display: inline-block;
    width: 10px;
    height: 10px;
  }
</style>
